import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastOptions = {
	autoClose: 3000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: false,
	draggable: true,
	progress: undefined,
	theme: "light",
};

const fallbackMessages = {
	400: "Confira os dados informados e tente novamente.",
	401: "Sessão expirada ou login inválido. Entre novamente.",
	403: "Você não tem permissão para esta ação.",
	404: "Registro não encontrado.",
	409: "Este registro já existe ou está em conflito.",
	413: "Arquivo muito grande para envio.",
	422: "Alguns dados informados não são válidos.",
	429: "Muitas tentativas. Aguarde um pouco e tente novamente.",
	default: "Não foi possível concluir a operação. Tente novamente.",
	network: "Não foi possível conectar ao servidor. Verifique sua internet e tente novamente.",
	timeout: "A operação demorou muito para responder. Tente novamente.",
	server: "O servidor não conseguiu concluir a operação. Tente novamente em instantes.",
};

const technicalPatterns = [
	/<\/?[a-z][\s\S]*>/i,
	/<!doctype/i,
	/\b(stack|trace|sequelize|postgres|sql|select|insert|update|delete|constraint)\b/i,
	/\b(password|token|secret|authorization)\b/i,
	/\/home\/|\/var\/|\\src\\|\.ts:\d+|\.js:\d+/i,
];

const normalizeMessage = message => {
	if (!message || typeof message !== "string") return "";
	return message.trim().replace(/\s+/g, " ");
};

const isBackendErrorCode = message => /^ERR_[A-Z0-9_]+$/.test(message);

const isSafeMessage = message => {
	if (!message || message.length > 180) return false;
	if (isBackendErrorCode(message)) return false;
	return !technicalPatterns.some(pattern => pattern.test(message));
};

const getResponseMessage = err => {
	const data = err?.response?.data;

	if (isString(data)) return normalizeMessage(data);
	if (!data || typeof data !== "object") return "";

	return normalizeMessage(data.error || data.message || data.details);
};

const getFallbackMessage = err => {
	const status = err?.response?.status;
	const code = err?.code;
	const message = normalizeMessage(err?.message);

	if (code === "ECONNABORTED" || /timeout/i.test(message)) {
		return fallbackMessages.timeout;
	}

	if (!err?.response) {
		return fallbackMessages.network;
	}

	if (status >= 500) {
		return fallbackMessages.server;
	}

	return fallbackMessages[status] || fallbackMessages.default;
};

const toastError = err => {
	const errorMsg = getResponseMessage(err);

	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				...toastOptions,
			});
			return
		}

		if (isSafeMessage(errorMsg)) {
			toast.error(errorMsg, {
				toastId: errorMsg,
				...toastOptions,
			});
			return
		}
	}

	if (isString(err)) {
		const message = normalizeMessage(err);
		toast.error(message || fallbackMessages.default, {
			toastId: message || fallbackMessages.default,
			...toastOptions,
		});
		return
	} else {
		const fallbackMessage = getFallbackMessage(err);
		toast.error(fallbackMessage, {
			toastId: fallbackMessage,
			...toastOptions,
		});
		return
	}
};

export default toastError;
